import EcoImg from 'eco-design-components/base/eco-img';
import EcoSpace from 'eco-design-components/base/eco-space';
import css from './index.module.scss';

const N: React.FC = () => {
    return (
        <div id="rapid-pro-N" className={`rapid-pro-N ${css.section} GtmModuleData-section`} data-section-id={'N'}>
            <EcoSpace />
            <EcoImg
                pc="https://websiteoss.ecoflow.com/upload/image/1749804772138/N-pc.jpg"
                pad="https://websiteoss.ecoflow.com/upload/image/1749804772138/N-pc.jpg"
                h5="https://websiteoss.ecoflow.com/upload/image/1749804771929/N-h5.jpg"
            />
            <EcoSpace />
        </div>
    );
};

export default N;
